import { useEffect, useState } from "react";
import { useRootStore } from "../hooks/useRootStore";
import type { Employee } from '../data/Employee';
import { List, ListItem } from "@mui/material";
import { AgentType } from "../data/AgentType";

export default function EmployeeList() {
    const { api } = useRootStore();

    const [loading, setLoading] = useState(true);
    const [employees, setEmployees] = useState([]as Employee[]);

    useEffect(() => {
        api.getEmployees(AgentType.Employee).then(e => {
            setEmployees(e as Employee[]);
            setLoading(false);
        });

    }, [api]);

    return (
        loading ? 'Загрузка' :
            <List>
                {employees.map(e => <ListItem key={e.ID}>{e.Name}</ListItem>)}
            </List>
    );
}